import { Flex } from "common/components/flex/flex";
import { SectionError } from "features/dashboard/components/sectionError";
import { TASK_GROUPS } from "features/dashboard/sections/tasks/taskGroups";
import styles from "features/dashboard/sections/tasks/tasksContent/tasksContent.module.scss";
import { TaskGroup } from "features/dashboard/sections/tasks/tasksContent/taskGroup/taskGroup";

export const TasksContent = ({
  data,
  error,
  loading,
  onRetry,
  getDueDateForGroup,
  getGroupDescription,
}) => {
  if (error && !loading) {
    return <SectionError message={error.message} onRetry={onRetry} />;
  }

  return (
    <Flex gap={12} className={`scrollable-container ${styles.tasks}`}>
      {TASK_GROUPS.map((group) => (
        <TaskGroup
          key={group.key}
          testId={group.testId}
          label={group.label}
          description={getGroupDescription(group)}
          icon={group.icon}
          loading={loading}
          tasks={data[group.key] ?? []}
          getStatus={group.getStatus}
          getDueTime={group.getDueTime}
          getDueDate={getDueDateForGroup(group)}
        />
      ))}
    </Flex>
  );
};
